import TenantChatPhase from './TenantChatPhase.vue';

export default TenantChatPhase;